"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MessageBubble;
var _react = _interopRequireWildcard(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _remarkGfm = _interopRequireDefault(require("remark-gfm"));
var _Avatar = require("./Avatar");
var _constants = require("./constants");
var _AssistantProvider = require("./AssistantProvider");
var _ModernStructuredMessage = _interopRequireDefault(require("./ModernStructuredMessage"));
var _StructuredCards = require("./StructuredCards");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function MessageBubble(_ref) {
  let {
    message,
    userName,
    isLast = false,
    mode = 'sidebar'
  } = _ref;
  const isUser = message.role === _constants.ROLES.USER;
  const hasJson = !!message.json;
  const showAiMeta = !isUser && message.isAiGenerated === true;
  const {
    goldenId,
    addMessage,
    sidebarOpen,
    openFeedback
  } = (0, _AssistantProvider.useAssistant)();
  const isStandalone = mode === 'standalone';
  const [reportConfirmed, setReportConfirmed] = (0, _react.useState)(false);
  const handleAddMessages = msgs => {
    if (!msgs || !Array.isArray(msgs)) return;
    msgs.forEach(m => {
      const extra = {};
      if (m.json) extra.json = m.json;
      if (m.isAiGenerated) extra.isAiGenerated = true;
      addMessage(m.role, m.text, extra);
    });
  };
  const userBubbleStyle = {
    padding: isStandalone ? '12px 18px' : '10px 14px',
    borderRadius: isStandalone ? '18px' : '14px',
    borderBottomRightRadius: '4px',
    background: 'linear-gradient(135deg, #1976d2 0%, #7c3aed 100%)',
    color: '#fff',
    minWidth: 0,
    overflow: 'hidden',
    fontSize: isStandalone ? '15px' : undefined,
    lineHeight: isStandalone ? '1.6' : undefined
  };
  const agentBubbleStyle = isStandalone ? {
    padding: '20px 24px',
    borderRadius: '16px',
    background: '#ffffff',
    color: '#1a1a2e',
    border: '1px solid rgba(0,0,0,0.06)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)',
    minWidth: 0,
    overflow: 'hidden',
    fontSize: '15px',
    lineHeight: '1.65',
    letterSpacing: '-0.01em'
  } : {
    padding: '12px 14px',
    borderRadius: '14px',
    borderBottomLeftRadius: '4px',
    background: '#ffffff',
    color: '#1c3144',
    border: '1px solid #d4dce6',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    minWidth: 0,
    overflow: 'hidden'
  };
  return (0, _jsxRuntime.jsxs)("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: isStandalone ? '12px' : '8px',
      maxWidth: isStandalone ? hasJson && !isUser ? message.dataRetrievalType ? '87%' : '80%' : '780px' : '88%',
      alignSelf: isUser ? 'flex-end' : 'flex-start',
      flexDirection: 'row'
    },
    className: "tw-group",
    children: [!isUser && (0, _jsxRuntime.jsx)(_Avatar.AgentAvatar, {}), (0, _jsxRuntime.jsxs)("div", {
      style: isUser ? userBubbleStyle : agentBubbleStyle,
      children: [showAiMeta && (0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '6px',
          gap: '8px'
        },
        children: [(0, _jsxRuntime.jsxs)("span", {
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '10px',
            fontWeight: 600,
            color: '#6366f1',
            background: '#eef2ff',
            padding: '2px 8px',
            borderRadius: '10px',
            letterSpacing: '0.02em',
            textTransform: 'uppercase',
            lineHeight: 1.4
          },
          children: [(0, _jsxRuntime.jsxs)("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("path", {
              d: "M12 2L2 7l10 5 10-5-10-5z"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M2 17l10 5 10-5"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M2 12l10 5 10-5"
            })]
          }), "AI Generated"]
        }), (0, _jsxRuntime.jsxs)("button", {
          onClick: () => openFeedback(message.id),
          title: "Report an issue with this response",
          "aria-label": "Report an issue with this response",
          style: {
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '2px 6px',
            borderRadius: '6px',
            color: '#94a3b8',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '3px',
            fontSize: '10px',
            transition: 'color 0.15s, background 0.15s'
          },
          onMouseEnter: e => {
            e.currentTarget.style.color = '#ef4444';
            e.currentTarget.style.background = '#fef2f2';
          },
          onMouseLeave: e => {
            e.currentTarget.style.color = '#94a3b8';
            e.currentTarget.style.background = 'transparent';
          },
          children: [(0, _jsxRuntime.jsxs)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("path", {
              d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
            }), (0, _jsxRuntime.jsx)("line", {
              x1: "4",
              y1: "22",
              x2: "4",
              y2: "15"
            })]
          }), "Report"]
        })]
      }), message.text && (isUser ? (0, _jsxRuntime.jsx)("span", {
        children: message.text
      }) : (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
        remarkPlugins: [_remarkGfm.default],
        children: message.text
      })), hasJson && (() => {
        const json = message.json;
        if (json.error) {
          return (0, _jsxRuntime.jsx)(_StructuredCards.ErrorCard, {
            data: json
          });
        }
        if (message.dataRetrievalType) {
          return (0, _jsxRuntime.jsx)(_StructuredCards.DataRetrievalCard, {
            data: json,
            requestText: message.requestText
          });
        }
        const msg = json === null || json === void 0 ? void 0 : json.message;
        if (msg !== null && msg !== void 0 && msg.data_correction || msg !== null && msg !== void 0 && msg.entity_summary || msg !== null && msg !== void 0 && msg.analysis || msg !== null && msg !== void 0 && msg.result) {
          return (0, _jsxRuntime.jsx)(_ModernStructuredMessage.default, {
            data: json,
            goldenID: goldenId,
            onAddMessages: handleAddMessages,
            isSidebar: sidebarOpen,
            messageId: message.id,
            mode: mode
          });
        }
        return (0, _jsxRuntime.jsx)(_StructuredCards.GenericResultCard, {
          data: json
        });
      })(), (0, _jsxRuntime.jsx)("span", {
        className: "tw-block tw-text-[10px] tw-mt-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity",
        style: {
          color: isUser ? 'rgba(255,255,255,0.6)' : '#7F95A4'
        },
        children: new Date(message.createdAt).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      })]
    }), isUser && (0, _jsxRuntime.jsx)(_Avatar.UserAvatar, {
      userName: userName
    })]
  });
}